module.exports = __webpack_public_path__ + "img/组 8462@2x.0183618d.png";